export default{
	portalBaseURL: 'https://all.taxunion.com.cn/#/Homepage',//门户首页
	baseURL:'https://fin.amc-invoice.com:8443/fvm/',
	//测试
	projectType:"",// 默认空，空代表产品部署，
	portalSwitch: false,

}

